// import axios from 'axios';
// import { request } from './axiosFun';
// export const deviceList = (params) => { return request("post", "/est/api/pcController/getDeviceByUser", params) };
// export cons
import request from './axiosFun'
// 人员列表
var url = ''
if (process.env.NODE_ENV === 'development') {
  url = '/est'
} else {
  url = ''
}
// 初始设备列表
export function listApi (data) {
  return request({
    url: url + '/device/cameraDevice/getUserDsList',
    method: 'post',
    data,
    notoken: 'old'
  })
}
export function detailApi (data) {
  return request({
    url: url + '/device/cameraDevice/dsView',
    method: 'post',
    data,
    notoken: 'old'
  })
}
// 发送验证码

export function sendCodeApi (data) {
  return request({
    url: url + '/base-server/aliOperate/smsCode',
    method: 'post',
    data
  })
}
// 修改密码

export function editPwdApi (data) {
  return request({
    url: url + '/base-server/loginInfo/forgotPwd',
    method: 'post',
    data
  })
}
// 注册

export function registerApi (data) {
  return request({
    url: url + '/pasture/userInfo/register',
    method: 'post',
    data,
    notoken: 'old'
  })
}
// 验证码登录
export function accountSmsLoginApi (data) {
  return request({
    url: url + '/pasture/userInfo/accountSmsLogin',
    method: 'post',
    data,
    notoken: 'old'
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js